document.getElementById("casualShirtsTab").style.display ="none";
document.getElementById("bottomsTab").style.display ="none";
document.getElementById("outwearTab").style.display ="none";

document.getElementById("bottomsPrefferedFitTab").style.display ="none";
document.getElementById("casualShirtsPrefferedFitTab").style.display ="none";

document.getElementById("dressShirtsTabBtn").style.color = "black";
document.getElementById("dressShirtsTabBtn").style.borderColor = "black";

document.getElementById("dressShirtSizeTables").style.display ="block";
document.getElementById("casualShirtSizeTables").style.display ="none";
document.getElementById("bottomSizeTables").style.display ="none";
document.getElementById("outwearSizeTables").style.display ="none";

document.getElementById("dressCasualMeasureTab").style.display ="block";
document.getElementById("bottomOutwearMeasureTab").style.display ="none";


function showDressShirts() {
  document.getElementById("casualShirtsTab").style.display ="none"
  
  document.getElementById("bottomsTab").style.display ="none";
  document.getElementById("bottomsTabBtn").style.borderColor = "white";
 
  document.getElementById("outwearTab").style.display ="none";
  document.getElementById("outwearTabBtn").style.borderColor = "white";
  
  document.getElementById("outwearTabBtn").style.color = "#696969";
  document.getElementById("bottomsTabBtn").style.color = "#696969";
  document.getElementById("casualShirtsTabBtn").style.color = "#696969";
  document.getElementById("casualShirtsTabBtn").style.borderColor = "white";
   document.getElementById("dressShirtsTabBtn").style.color = "black";
  
  document.getElementById("dressShirtsTab").style.display ="flex";
  document.getElementById("dressShirtsTabBtn").style.borderColor = "black";
 

  document.getElementById("bottomsPrefferedFitTab").style.display ="none";
  document.getElementById("casualShirtsPrefferedFitTab").style.display ="none";  
  document.getElementById("dressShirtsPrefferedFitTab").style.display ="flex";

  document.getElementById("dressShirtSizeTables").style.display ="block";
  document.getElementById("casualShirtSizeTables").style.display ="none";
  document.getElementById("bottomSizeTables").style.display ="none";
  document.getElementById("outwearSizeTables").style.display ="none";

  document.getElementById("dressCasualMeasureTab").style.display ="block";
  document.getElementById("bottomOutwearMeasureTab").style.display ="none";
}
function showCasualShirts() {
  document.getElementById("bottomsTab").style.display ="none";
  document.getElementById("bottomsTabBtn").style.borderColor = "white";
  document.getElementById("outwearTab").style.display ="none";
  document.getElementById("outwearTabBtn").style.borderColor = "white";
  document.getElementById("dressShirtsTab").style.display ="none";
  document.getElementById("dressShirtsTabBtn").style.borderColor = "white";

    document.getElementById("outwearTabBtn").style.color = "#696969";
  document.getElementById("bottomsTabBtn").style.color = "#696969";
  document.getElementById("casualShirtsTabBtn").style.color = "black";
   document.getElementById("dressShirtsTabBtn").style.color = "#696969";
  
  document.getElementById("casualShirtsTab").style.display ="flex";
  document.getElementById("casualShirtsTabBtn").style.borderColor = "black";

  document.getElementById("bottomsPrefferedFitTab").style.display ="none";
  document.getElementById("dressShirtsPrefferedFitTab").style.display ="none";
  document.getElementById("casualShirtsPrefferedFitTab").style.display ="flex";

  document.getElementById("dressShirtSizeTables").style.display ="none";
  document.getElementById("casualShirtSizeTables").style.display ="block";
  document.getElementById("bottomSizeTables").style.display ="none";
  document.getElementById("outwearSizeTables").style.display ="none";

  document.getElementById("dressCasualMeasureTab").style.display ="block";
  document.getElementById("bottomOutwearMeasureTab").style.display ="none";
}
function showBottoms() {
  document.getElementById("outwearTab").style.display ="none";
  document.getElementById("outwearTabBtn").style.borderColor = "white";
  document.getElementById("dressShirtsTab").style.display ="none";
  document.getElementById("dressShirtsTabBtn").style.borderColor = "white";
  document.getElementById("casualShirtsTab").style.display ="none";
  document.getElementById("casualShirtsTabBtn").style.borderColor = "white";
  
  document.getElementById("bottomsTab").style.display ="flex";
  document.getElementById("bottomsTabBtn").style.borderColor = "black";
  
  document.getElementById("bottomsTabBtn").style.color = "black";
  document.getElementById("outwearTabBtn").style.color = "#696969";
  document.getElementById("casualShirtsTabBtn").style.color = "#696969";
  document.getElementById("dressShirtsTabBtn").style.color = "#696969";

  document.getElementById("dressShirtsPrefferedFitTab").style.display ="none";
  document.getElementById("casualShirtsPrefferedFitTab").style.display ="none";
  document.getElementById("bottomsPrefferedFitTab").style.display ="flex";

  document.getElementById("dressShirtSizeTables").style.display ="none";
  document.getElementById("casualShirtSizeTables").style.display ="none";
  document.getElementById("bottomSizeTables").style.display ="block";
  document.getElementById("outwearSizeTables").style.display ="none";

  document.getElementById("dressCasualMeasureTab").style.display ="none";
  document.getElementById("bottomOutwearMeasureTab").style.display ="block";
}
function showOutwear() {
  document.getElementById("dressShirtsTab").style.display ="none";
  document.getElementById("dressShirtsTabBtn").style.borderColor = "white";
  document.getElementById("casualShirtsTab").style.display ="none";
  document.getElementById("casualShirtsTabBtn").style.borderColor = "white";
  document.getElementById("bottomsTab").style.display ="none";
  document.getElementById("bottomsTabBtn").style.borderColor = "white";
    
  document.getElementById("outwearTab").style.display ="flex";
  document.getElementById("outwearTabBtn").style.borderColor = "black";
  
  document.getElementById("outwearTabBtn").style.color = "black";
  document.getElementById("bottomsTabBtn").style.color = "#696969";
  document.getElementById("casualShirtsTabBtn").style.color = "#696969";
  document.getElementById("dressShirtsTabBtn").style.color = "#696969";

  document.getElementById("dressShirtsPrefferedFitTab").style.display ="none";
  document.getElementById("casualShirtsPrefferedFitTab").style.display ="none";
  document.getElementById("bottomsPrefferedFitTab").style.display ="flex";  

  document.getElementById("dressShirtSizeTables").style.display ="none";
  document.getElementById("casualShirtSizeTables").style.display ="none";
  document.getElementById("bottomSizeTables").style.display ="none";
  document.getElementById("outwearSizeTables").style.display ="block";

  document.getElementById("dressCasualMeasureTab").style.display ="none";
  document.getElementById("bottomOutwearMeasureTab").style.display ="block";
  
}


document.getElementById("dressShirtsTabBtn").onclick = function() {showDressShirts()};
document.getElementById("casualShirtsTabBtn").onclick = function() {showCasualShirts()};
document.getElementById("bottomsTabBtn").onclick = function() {showBottoms()};
document.getElementById("outwearTabBtn").onclick = function() {showOutwear()};



/* working shirt wear size table functionality */
document.getElementById("slimFitTab").style.display ="flex";
document.getElementById("bigTallTab").style.display ="none";
document.getElementById("regularFitTab").style.display ="none";

document.getElementById("slimFitTabBtn").style.color = "black";
document.getElementById("slimFitTabBtn").style.borderColor = "black";

function showSlimFitSizeTable() {
  document.getElementById("slimFitTab").style.display ="flex";
  document.getElementById("bigTallTab").style.display ="none";
  document.getElementById("regularFitTab").style.display ="none";

  document.getElementById("slimFitTabBtn").style.color = "black";
document.getElementById("bigTallTabBtn").style.color = "#696969";
document.getElementById("regularFitTabBtn").style.color = "#696969";
  
  document.getElementById("slimFitTabBtn").style.borderColor = "black";
  document.getElementById("bigTallTabBtn").style.borderColor = "white";
  document.getElementById("regularFitTabBtn").style.borderColor = "white";
}
function showBigTallSizeTable() {
  document.getElementById("slimFitTab").style.display ="none";
  document.getElementById("bigTallTab").style.display ="flex";
  document.getElementById("regularFitTab").style.display ="none";

  document.getElementById("bigTallTabBtn").style.color = "black";
  document.getElementById("slimFitTabBtn").style.color = "#696969";
document.getElementById("regularFitTabBtn").style.color = "#696969";
  
  document.getElementById("bigTallTabBtn").style.borderColor = "black";
  document.getElementById("slimFitTabBtn").style.borderColor = "white";
  document.getElementById("regularFitTabBtn").style.borderColor = "white";
}
function showRegularSizeTable() {
  document.getElementById("slimFitTab").style.display ="none";
  document.getElementById("bigTallTab").style.display ="none";
  document.getElementById("regularFitTab").style.display ="flex";

  document.getElementById("regularFitTabBtn").style.color = "black";
  document.getElementById("bigTallTabBtn").style.color = "#696969";
  document.getElementById("slimFitTabBtn").style.color = "#696969";

  
  document.getElementById("regularFitTabBtn").style.borderColor = "black";
  document.getElementById("bigTallTabBtn").style.borderColor = "white";
  document.getElementById("slimFitTabBtn").style.borderColor = "white";
  
}
document.getElementById("slimFitTabBtn").onclick = function() {showSlimFitSizeTable()};
document.getElementById("bigTallTabBtn").onclick = function() {showBigTallSizeTable()};
document.getElementById("regularFitTabBtn").onclick = function() {showRegularSizeTable()};


/* casual wear size table functionality */
document.getElementById("reworkedTab").style.display ="flex";
document.getElementById("stretchTab").style.display ="none";
document.getElementById("henleyTab").style.display ="none";
document.getElementById("tShirtTab").style.display ="none";

document.getElementById("reworkedTabBtn").style.color = "black";
document.getElementById("reworkedTabBtn").style.borderColor = "black";

function showReworkedSizeTable() {
  document.getElementById("stretchTab").style.display ="none";
  document.getElementById("henleyTab").style.display ="none";
  document.getElementById("tShirtTab").style.display ="none";
  document.getElementById("reworkedTab").style.display ="flex";

  document.getElementById("reworkedTabBtn").style.color = "black";
  document.getElementById("stretchTabBtn").style.color = "#696969";
  document.getElementById("henleyTabBtn").style.color = "#696969";
  document.getElementById("tShirtTabBtn").style.color = "#696969";
  
  document.getElementById("reworkedTabBtn").style.borderColor = "black";
  document.getElementById("stretchTabBtn").style.borderColor = "white";
  document.getElementById("henleyTabBtn").style.borderColor = "white";
  document.getElementById("tShirtTabBtn").style.borderColor = "white";
  
}
function showStretchSizeTable() {
  document.getElementById("stretchTab").style.display ="flex";
  document.getElementById("henleyTab").style.display ="none";
  document.getElementById("tShirtTab").style.display ="none";
  document.getElementById("reworkedTab").style.display ="none";

  document.getElementById("stretchTabBtn").style.color = "black";
  document.getElementById("reworkedTabBtn").style.color = "#696969";
  document.getElementById("henleyTabBtn").style.color = "#696969";
  document.getElementById("tShirtTabBtn").style.color = "#696969";
  
  document.getElementById("stretchTabBtn").style.borderColor = "black";
  document.getElementById("reworkedTabBtn").style.borderColor = "white";
  document.getElementById("henleyTabBtn").style.borderColor = "white";
  document.getElementById("tShirtTabBtn").style.borderColor = "white";
  
}
function showHenleySizeTable() {
  document.getElementById("stretchTab").style.display ="none";
  document.getElementById("henleyTab").style.display ="flex";
  document.getElementById("tShirtTab").style.display ="none";
  document.getElementById("reworkedTab").style.display ="none";

  document.getElementById("henleyTabBtn").style.color = "black";
  document.getElementById("stretchTabBtn").style.color = "#696969";
  document.getElementById("reworkedTabBtn").style.color = "#696969";
  document.getElementById("tShirtTabBtn").style.color = "#696969";
  
  document.getElementById("henleyTabBtn").style.borderColor = "black";
  document.getElementById("stretchTabBtn").style.borderColor = "white";
  document.getElementById("reworkedTabBtn").style.borderColor = "white";
  document.getElementById("tShirtTabBtn").style.borderColor = "white";
  
}
function showTshirtSizeTable() {
  document.getElementById("stretchTab").style.display ="none";
  document.getElementById("henleyTab").style.display ="none";
  document.getElementById("tShirtTab").style.display ="flex";
  document.getElementById("reworkedTab").style.display ="none";

  document.getElementById("tShirtTabBtn").style.color = "black";
  document.getElementById("henleyTabBtn").style.color = "#696969";
  document.getElementById("stretchTabBtn").style.color = "#696969";
  document.getElementById("reworkedTabBtn").style.color = "#696969";

  
  document.getElementById("tShirtTabBtn").style.borderColor = "black";
  document.getElementById("stretchTabBtn").style.borderColor = "white";
  document.getElementById("henleyTabBtn").style.borderColor = "white";
  document.getElementById("reworkedTabBtn").style.borderColor = "white";
  
}
document.getElementById("reworkedTabBtn").onclick = function() {showReworkedSizeTable()};
document.getElementById("stretchTabBtn").onclick = function() {showStretchSizeTable()};
document.getElementById("henleyTabBtn").onclick = function() {showHenleySizeTable()};
document.getElementById("tShirtTabBtn").onclick = function() {showTshirtSizeTable()};



/* bottom wear size table functionality */
document.getElementById("pocketPantsTab").style.display ="flex";
document.getElementById("knitTrousersTab").style.display ="none";
document.getElementById("joggersTab").style.display ="none";
document.getElementById("shortsTab").style.display ="none";
document.getElementById("swimTab").style.display ="none";

document.getElementById("pocketpantsTabBtn").style.color = "black";
document.getElementById("pocketpantsTabBtn").style.borderColor = "black";
function showPocketPantsSizeTable() {
  document.getElementById("pocketPantsTab").style.display ="flex";
  document.getElementById("knitTrousersTab").style.display ="none";
  document.getElementById("joggersTab").style.display ="none";
  document.getElementById("shortsTab").style.display ="none";
  document.getElementById("swimTab").style.display ="none";

  document.getElementById("pocketpantsTabBtn").style.color = "black";
  document.getElementById("trousersTabBtn").style.color = "#696969";
  document.getElementById("joggersTabBtn").style.color = "#696969";
  document.getElementById("shortsTabBtn").style.color = "#696969";
  document.getElementById("swimTabBtn").style.color = "#696969";
  
  document.getElementById("pocketpantsTabBtn").style.borderColor = "black";
  document.getElementById("trousersTabBtn").style.borderColor = "white";
  document.getElementById("joggersTabBtn").style.borderColor = "white";
  document.getElementById("shortsTabBtn").style.borderColor = "white";
  document.getElementById("swimTabBtn").style.borderColor = "white";
  
}
function showTrousersSizeTable() {
  document.getElementById("pocketPantsTab").style.display ="none";
  document.getElementById("knitTrousersTab").style.display ="flex";
  document.getElementById("joggersTab").style.display ="none";
  document.getElementById("shortsTab").style.display ="none";
  document.getElementById("swimTab").style.display ="none";


  document.getElementById("trousersTabBtn").style.color = "black";
  document.getElementById("pocketpantsTabBtn").style.color = "#696969";
  document.getElementById("joggersTabBtn").style.color = "#696969";
  document.getElementById("shortsTabBtn").style.color = "#696969";
  document.getElementById("swimTabBtn").style.color = "#696969";

  
  document.getElementById("trousersTabBtn").style.borderColor = "black";
  document.getElementById("pocketpantsTabBtn").style.borderColor = "white";
  document.getElementById("joggersTabBtn").style.borderColor = "white";
  document.getElementById("shortsTabBtn").style.borderColor = "white";
  document.getElementById("swimTabBtn").style.borderColor = "white"; 
}
function showJoggersSizeTable() {
  document.getElementById("pocketPantsTab").style.display ="none";
  document.getElementById("knitTrousersTab").style.display ="none";
  document.getElementById("joggersTab").style.display ="flex";
  document.getElementById("shortsTab").style.display ="none";
  document.getElementById("swimTab").style.display ="none";


  document.getElementById("joggersTabBtn").style.color = "black";
  document.getElementById("trousersTabBtn").style.color = "#696969";
  document.getElementById("pocketpantsTabBtn").style.color = "#696969";
  document.getElementById("shortsTabBtn").style.color = "#696969";
  document.getElementById("swimTabBtn").style.color = "#696969";
  
  document.getElementById("joggersTabBtn").style.borderColor = "black";
  document.getElementById("pocketpantsTabBtn").style.borderColor = "white";
  document.getElementById("trousersTabBtn").style.borderColor = "white";
  document.getElementById("shortsTabBtn").style.borderColor = "white";
  document.getElementById("swimTabBtn").style.borderColor = "white"; 
}
function showShortsSizeTable() {
  document.getElementById("pocketPantsTab").style.display ="none";
  document.getElementById("knitTrousersTab").style.display ="none";
  document.getElementById("joggersTab").style.display ="none";
  document.getElementById("shortsTab").style.display ="flex";
  document.getElementById("swimTab").style.display ="none";


  document.getElementById("shortsTabBtn").style.color = "black";
  document.getElementById("joggersTabBtn").style.color = "#696969";
  document.getElementById("trousersTabBtn").style.color = "#696969";
  document.getElementById("pocketpantsTabBtn").style.color = "#696969";
  document.getElementById("swimTabBtn").style.color = "#696969";
  
  document.getElementById("shortsTabBtn").style.borderColor = "black";
  document.getElementById("pocketpantsTabBtn").style.borderColor = "white";
  document.getElementById("trousersTabBtn").style.borderColor = "white";
  document.getElementById("joggersTabBtn").style.borderColor = "white";
  document.getElementById("swimTabBtn").style.borderColor = "white"; 
}
function showSwimSizeTable() {
  document.getElementById("pocketPantsTab").style.display ="none";
  document.getElementById("knitTrousersTab").style.display ="none";
  document.getElementById("joggersTab").style.display ="none";
  document.getElementById("shortsTab").style.display ="none";
  document.getElementById("swimTab").style.display ="flex";


  document.getElementById("swimTabBtn").style.color = "black";
  document.getElementById("shortsTabBtn").style.color = "#696969";
  document.getElementById("joggersTabBtn").style.color = "#696969";
  document.getElementById("trousersTabBtn").style.color = "#696969";
  document.getElementById("pocketpantsTabBtn").style.color = "#696969";
  
  document.getElementById("swimTabBtn").style.borderColor = "black";
  document.getElementById("pocketpantsTabBtn").style.borderColor = "white";
  document.getElementById("trousersTabBtn").style.borderColor = "white";
  document.getElementById("joggersTabBtn").style.borderColor = "white";
  document.getElementById("shortsTabBtn").style.borderColor = "white"; 
}
document.getElementById("pocketpantsTabBtn").onclick = function() {showPocketPantsSizeTable()};
document.getElementById("trousersTabBtn").onclick = function() {showTrousersSizeTable()};
document.getElementById("joggersTabBtn").onclick = function() {showJoggersSizeTable()};
document.getElementById("shortsTabBtn").onclick = function() {showShortsSizeTable()};
document.getElementById("swimTabBtn").onclick = function() {showSwimSizeTable()};



/* outwear wear size table functionality */
  document.getElementById("hoodiesTab").style.display ="none";
  document.getElementById("shortJacketTab").style.display ="none";
  document.getElementById("bomberJacketTab").style.display ="none";
  document.getElementById("utilityCoatTab").style.display ="none";
  document.getElementById("knitBlazerTab").style.display ="flex";

document.getElementById("knitBlazerTabBtn").style.color = "black";
document.getElementById("knitBlazerTabBtn").style.borderColor = "black";
function showKnitBlazerSizeTable() {
  document.getElementById("hoodiesTab").style.display ="none";
  document.getElementById("shortJacketTab").style.display ="none";
  document.getElementById("bomberJacketTab").style.display ="none";
  document.getElementById("utilityCoatTab").style.display ="none";
  document.getElementById("knitBlazerTab").style.display ="flex";


  document.getElementById("knitBlazerTabBtn").style.color = "black";
  document.getElementById("utilityCoatTabBtn").style.color = "#696969";
  document.getElementById("bomberJacketTabBtn").style.color = "#696969";
  document.getElementById("shortJacketTabBtn").style.color = "#696969";
  document.getElementById("hoodiesTabBtn").style.color = "#696969"; 

  document.getElementById("knitBlazerTabBtn").style.borderColor = "black";
  document.getElementById("utilityCoatTabBtn").style.borderColor = "white";
  document.getElementById("bomberJacketTabBtn").style.borderColor = "white";
  document.getElementById("shortJacketTabBtn").style.borderColor = "white";
  document.getElementById("hoodiesTabBtn").style.borderColor = "white"; 
}
function showUtilityCoatSizeTable() {
  document.getElementById("hoodiesTab").style.display ="none";
  document.getElementById("shortJacketTab").style.display ="none";
  document.getElementById("bomberJacketTab").style.display ="none";
  document.getElementById("utilityCoatTab").style.display ="flex";
  document.getElementById("knitBlazerTab").style.display ="none";


  document.getElementById("utilityCoatTabBtn").style.color = "black";
  document.getElementById("knitBlazerTabBtn").style.color = "#696969";
  document.getElementById("bomberJacketTabBtn").style.color = "#696969";
  document.getElementById("shortJacketTabBtn").style.color = "#696969";
  document.getElementById("hoodiesTabBtn").style.color = "#696969"; 
  
  document.getElementById("utilityCoatTabBtn").style.borderColor = "black";
  document.getElementById("knitBlazerTabBtn").style.borderColor = "white";
  document.getElementById("bomberJacketTabBtn").style.borderColor = "white";
  document.getElementById("shortJacketTabBtn").style.borderColor = "white";
  document.getElementById("hoodiesTabBtn").style.borderColor = "white"; 
}
function showBomberJacketSizeTable() {
  document.getElementById("hoodiesTab").style.display ="none";
  document.getElementById("shortJacketTab").style.display ="none";
  document.getElementById("bomberJacketTab").style.display ="flex";
  document.getElementById("utilityCoatTab").style.display ="none";
  document.getElementById("knitBlazerTab").style.display ="none";


  document.getElementById("bomberJacketTabBtn").style.color = "black";
  document.getElementById("utilityCoatTabBtn").style.color = "#696969";
  document.getElementById("knitBlazerTabBtn").style.color = "#696969";
  document.getElementById("shortJacketTabBtn").style.color = "#696969";
  document.getElementById("hoodiesTabBtn").style.color = "#696969"; 
  
  document.getElementById("bomberJacketTabBtn").style.borderColor = "black";
  document.getElementById("utilityCoatTabBtn").style.borderColor = "white";
  document.getElementById("knitBlazerTabBtn").style.borderColor = "white";
  document.getElementById("shortJacketTabBtn").style.borderColor = "white";
  document.getElementById("hoodiesTabBtn").style.borderColor = "white"; 
}
function showShortJacketSizeTable() {
  document.getElementById("hoodiesTab").style.display ="none";
  document.getElementById("shortJacketTab").style.display ="flex";
  document.getElementById("bomberJacketTab").style.display ="none";
  document.getElementById("utilityCoatTab").style.display ="none";
  document.getElementById("knitBlazerTab").style.display ="none";


  document.getElementById("shortJacketTabBtn").style.color = "black";
  document.getElementById("bomberJacketTabBtn").style.color = "#696969";
  document.getElementById("utilityCoatTabBtn").style.color = "#696969";
  document.getElementById("knitBlazerTabBtn").style.color = "#696969";
  document.getElementById("hoodiesTabBtn").style.color = "#696969"; 
  
  document.getElementById("shortJacketTabBtn").style.borderColor = "black";
  document.getElementById("utilityCoatTabBtn").style.borderColor = "white";
  document.getElementById("bomberJacketTabBtn").style.borderColor = "white";
  document.getElementById("knitBlazerTabBtn").style.borderColor = "white";
  document.getElementById("hoodiesTabBtn").style.borderColor = "white"; 
}
function showHoodieSizeTable() {
  document.getElementById("hoodiesTab").style.display ="flex";
  document.getElementById("shortJacketTab").style.display ="none";
  document.getElementById("bomberJacketTab").style.display ="none";
  document.getElementById("utilityCoatTab").style.display ="none";
  document.getElementById("knitBlazerTab").style.display ="none";


  document.getElementById("hoodiesTabBtn").style.color = "black";
  document.getElementById("shortJacketTabBtn").style.color = "#696969";
  document.getElementById("bomberJacketTabBtn").style.color = "#696969";
  document.getElementById("utilityCoatTabBtn").style.color = "#696969";
  document.getElementById("knitBlazerTabBtn").style.color = "#696969";

  
  document.getElementById("hoodiesTabBtn").style.borderColor = "black";
  document.getElementById("utilityCoatTabBtn").style.borderColor = "white";
  document.getElementById("bomberJacketTabBtn").style.borderColor = "white";
  document.getElementById("shortJacketTabBtn").style.borderColor = "white";
  document.getElementById("knitBlazerTabBtn").style.borderColor = "white"; 
}
document.getElementById("knitBlazerTabBtn").onclick = function() {showKnitBlazerSizeTable()};
document.getElementById("utilityCoatTabBtn").onclick = function() {showUtilityCoatSizeTable()};
document.getElementById("bomberJacketTabBtn").onclick = function() {showBomberJacketSizeTable()};
document.getElementById("shortJacketTabBtn").onclick = function() {showShortJacketSizeTable()};
document.getElementById("hoodiesTabBtn").onclick = function() {showHoodieSizeTable()};